import React from 'react';
import '../styles/next.sass';

const Next = () => {
  return (
    <div id='next'>
      <div id='nextDeveloper'>
        <h1>So why choose me for your next Junior Front-End Developer?</h1>
        <ul id='nextDeveloperList'>
          <li>
            <span></span>
            <p>
              you will gain a reliable team member, as you can learn from my
              history, I don't change jobs very often,
            </p>
          </li>
          <li>
            <span></span>
            <p>
              you'll hire someone, who is obsessed about coding, {`(right now I'm
              mostly into React)`},
            </p>
          </li>
          <li>
            <span></span>
            <p>
              your team will be working with someone, who has strong basics, I
              didn't just finish a bootcamp,
            </p>
          </li>
          <li>
            <span></span>
            <p>
              you will save time, because I can code for hours, and I'm good at
              scheduling my work,
            </p>
          </li>
          <li>
            <span></span>
            <p>
              you can be sure, that I care to get the job done, I know where to
              search for answers.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Next;
